<template>
  <div>
    <div class="content4 home-page">
      <div class="content4-header">
        <div class="content4-title-left"></div>
        <div class="content4-title">合作伙伴&客户</div>
        <div class="content4-title-right"></div>
      </div>
      <div class="content4-list">
        <div 
          v-for="(item, index) in partners" 
          :key="index"
          class="content4-list-item"
          :class="`content4-list-item${index + 1}`"

        >
          <img :src="item.img" :alt="item.name" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content4',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      partners: [
        { name: 'partner1', img: require('@/assets/logo_list_1.png'), link: 'https://example.com' },
        { name: 'partner2', img: require('@/assets/logo_list_2.png'), link: 'https://example.com' },
        { name: 'partner3', img: require('@/assets/logo_list_3.png'), link: 'https://example.com' },
        { name: 'partner4', img: require('@/assets/logo_list_4.png'), link: 'https://example.com' },
        { name: 'partner5', img: require('@/assets/logo_list_5.png'), link: 'https://example.com' },
        { name: 'partner6', img: require('@/assets/logo_list_6.png'), link: 'https://example.com' },
        { name: 'partner7', img: require('@/assets/logo_list_7.png'), link: 'https://example.com' },
        { name: 'partner8', img: require('@/assets/logo_list_8.png'), link: 'https://example.com' },
        { name: 'partner9', img: require('@/assets/logo_list_9.png'), link: 'https://example.com' },
        { name: 'partner10', img: require('@/assets/logo_list_10.png'), link: 'https://example.com' },
        { name: 'partner11', img: require('@/assets/logo_list_11.png'), link: 'https://example.com' },
        { name: 'partner12', img: require('@/assets/logo_list_12.png'), link: 'https://example.com' },
        { name: 'partner13', img: require('@/assets/logo_list_13.png'), link: 'https://example.com' },
        { name: 'partner14', img: require('@/assets/logo_list_14.png'), link: 'https://example.com' }
      ]
    }
  },
  methods: {
    handlePartnerClick(partner) {
      if (partner.link) {
        window.open(partner.link, '_blank')
      }
    }
  },
}
</script>

<style scoped>
.content4 {
  max-width: 1400px;
  margin: 0 auto;
  padding: 100px 40px;
  text-align: center;
  background: #ffffff;
}

.content4-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 60px;
  position: relative;
}

.content4-title-left,
.content4-title-right {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
  max-width: 300px;
}

.content4-title {
  font-size: 36px;
  font-weight: 600;
  color: #1a1a1a;
  padding: 0 30px;
  letter-spacing: -0.5px;
  position: relative;
}

.content4-title::after {
  content: '';
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 2px;
}

.content4-list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.content4-list-item {
  width: 186px;
  height: 90px;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
}

.content4-list-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.05) 0%, rgba(64, 169, 255, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.content4-list-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 40px rgba(24, 144, 255, 0.15);
  border-color: #1890ff;
}

.content4-list-item:hover::before {
  opacity: 1;
}

.content4-list-item img {
  max-width: 85%;
  max-height: 85%;
  object-fit: contain;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1;
}

.content4-list-item:hover img {
  transform: scale(1.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content4-title {
    font-size: 20px;
  }
  
  .content4-list-item {
    width: 120px;
    height: 60px;
  }
  
  .content4-title-left,
  .content4-title-right {
    max-width: 100px;
  }
}
</style>